// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 678 ? "component---src-pages-index-js" : chunkId) + "-" + {"231":"3b37b362858a798be917","610":"23aff928ca7400a262f3","678":"3b32248dde648b39e8f7","898":"a6d83bc5fdd54240f910"}[chunkId] + ".js";
};